var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useEffect, useState } from "react";
import { typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { deleteQuoteCommentAPI, getQuoteCommentsAPI, postQuoteCommentAPI, putQuoteCommentAPI, } from "../../../resources/helper/quoteComments";
import { showErrorToast } from "../../../fnx/showError";
import { showToastSuccessMessage } from "../../../fnx/sendSuccessMessage";
var mapApiCommentToCommentLike = function (item) {
    var _a;
    return ({
        id: item.id,
        content: item.content,
        creatorType: item.creatorType,
        creatorId: item.createdBy,
        creatorName: item.creatorName,
        createdAt: item.createdAt,
        updatedAt: item.updatedAt,
        repliedCommentId: (_a = item.repliedCommentId) !== null && _a !== void 0 ? _a : null,
        attachments: item.attachment ? [item.attachment] : [],
    });
};
var extractCommentsList = function (response) {
    var list = Array.isArray(response === null || response === void 0 ? void 0 : response.data) ? response.data : [];
    return list.map(mapApiCommentToCommentLike);
};
export var useQuoteComments = function (_a) {
    var quoteId = _a.quoteId, currentUserId = _a.currentUserId, currentUserName = _a.currentUserName, currentCreatorType = _a.currentCreatorType, _b = _a.initialComments, initialComments = _b === void 0 ? [] : _b, _c = _a.page, page = _c === void 0 ? 1 : _c, _d = _a.limit, limit = _d === void 0 ? 10 : _d, _e = _a.enable, enable = _e === void 0 ? true : _e, _f = _a.showComments, showComments = _f === void 0 ? true : _f, setSeeToast = _a.setSeeToast, t = _a.t;
    var _g = useState(initialComments), comments = _g[0], setComments = _g[1];
    var _h = useState(false), loadingPostComment = _h[0], setLoadingPostComment = _h[1];
    var _j = useState(false), loadingPutComment = _j[0], setLoadingPutComment = _j[1];
    var _k = useState(false), loadingDeleteComment = _k[0], setLoadingDeleteComment = _k[1];
    var _l = useState(false), loadingGetComments = _l[0], setLoadingGetComments = _l[1];
    var fetchComments = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1, errorForToast;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!quoteId || !showComments)
                        return [2 /*return*/];
                    setLoadingGetComments(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, getQuoteCommentsAPI(quoteId, {
                            enable: enable,
                            page: page,
                            limit: limit,
                        })];
                case 2:
                    response = _a.sent();
                    setComments(extractCommentsList(response));
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    errorForToast = {
                        errors: (error_1 === null || error_1 === void 0 ? void 0 : error_1.errors) || [],
                        message: (error_1 === null || error_1 === void 0 ? void 0 : error_1.message) ||
                            "No se pudieron cargar los comentarios. Intente nuevamente.",
                    };
                    showErrorToast(errorForToast, setSeeToast, t, true);
                    return [3 /*break*/, 5];
                case 4:
                    setLoadingGetComments(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [quoteId, enable, page, limit, showComments, setSeeToast, t]);
    useEffect(function () {
        fetchComments();
    }, [fetchComments]);
    var addComment = useCallback(function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var requestBody, response, created_1, error_2, errorForToast;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    if (!quoteId) {
                        showErrorToast({ message: "No se encontró la cotización para agregar el comentario." }, setSeeToast, t, true);
                        return [2 /*return*/];
                    }
                    requestBody = {
                        content: payload.content,
                        creatorType: (_a = payload.creatorType) !== null && _a !== void 0 ? _a : currentCreatorType,
                        repliedCommentId: (_b = payload.repliedCommentId) !== null && _b !== void 0 ? _b : undefined,
                        attachment: payload.attachments && payload.attachments.length > 0
                            ? payload.attachments[0]
                            : undefined,
                    };
                    setLoadingPostComment(true);
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, postQuoteCommentAPI(quoteId, requestBody)];
                case 2:
                    response = _g.sent();
                    created_1 = (_c = response === null || response === void 0 ? void 0 : response.data) !== null && _c !== void 0 ? _c : {
                        id: (_d = response === null || response === void 0 ? void 0 : response.id) !== null && _d !== void 0 ? _d : "tmp-".concat(Date.now(), "-").concat(Math.random().toString(36).slice(2, 8)),
                        content: payload.content,
                        creatorType: (_e = payload.creatorType) !== null && _e !== void 0 ? _e : currentCreatorType,
                        creatorId: currentUserId,
                        creatorName: currentUserName,
                        createdAt: new Date().toISOString(),
                        repliedCommentId: (_f = payload.repliedCommentId) !== null && _f !== void 0 ? _f : null,
                        attachments: payload.attachments,
                    };
                    setComments(function (prev) { return __spreadArray(__spreadArray([], prev, true), [created_1], false); });
                    showToastSuccessMessage("Comentario agregado correctamente", typeAlert.success, setSeeToast);
                    fetchComments();
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _g.sent();
                    errorForToast = {
                        errors: (error_2 === null || error_2 === void 0 ? void 0 : error_2.errors) || [],
                        message: (error_2 === null || error_2 === void 0 ? void 0 : error_2.message) ||
                            "No se pudo agregar el comentario. Intente nuevamente.",
                    };
                    showErrorToast(errorForToast, setSeeToast, t, true);
                    return [3 /*break*/, 5];
                case 4:
                    setLoadingPostComment(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [
        quoteId,
        currentCreatorType,
        currentUserId,
        currentUserName,
        setSeeToast,
        t,
        fetchComments,
    ]);
    var updateComment = useCallback(function (commentId, payload) { return __awaiter(void 0, void 0, void 0, function () {
        var requestBody, error_3, errorForToast;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!quoteId || !commentId) {
                        showErrorToast({ message: "No se pudo identificar el comentario a actualizar." }, setSeeToast, t, true);
                        return [2 /*return*/];
                    }
                    requestBody = {
                        content: payload.content,
                        creatorType: (_a = payload.creatorType) !== null && _a !== void 0 ? _a : currentCreatorType,
                        repliedCommentId: (_b = payload.repliedCommentId) !== null && _b !== void 0 ? _b : undefined,
                        attachment: payload.attachments && payload.attachments.length > 0
                            ? payload.attachments[0]
                            : undefined,
                    };
                    setLoadingPutComment(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, putQuoteCommentAPI(quoteId, commentId, requestBody)];
                case 2:
                    _c.sent();
                    showToastSuccessMessage("Comentario actualizado correctamente", typeAlert.success, setSeeToast);
                    fetchComments();
                    return [3 /*break*/, 5];
                case 3:
                    error_3 = _c.sent();
                    errorForToast = {
                        errors: (error_3 === null || error_3 === void 0 ? void 0 : error_3.errors) || [],
                        message: (error_3 === null || error_3 === void 0 ? void 0 : error_3.message) ||
                            "No se pudo actualizar el comentario. Intente nuevamente.",
                    };
                    showErrorToast(errorForToast, setSeeToast, t, true);
                    return [3 /*break*/, 5];
                case 4:
                    setLoadingPutComment(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [quoteId, currentCreatorType, setSeeToast, t, fetchComments]);
    var deleteComment = useCallback(function (commentId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_4, errorForToast;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!quoteId || !commentId) {
                        showErrorToast({ message: "No se pudo identificar el comentario a eliminar." }, setSeeToast, t, true);
                        return [2 /*return*/];
                    }
                    setLoadingDeleteComment(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, deleteQuoteCommentAPI(quoteId, commentId)];
                case 2:
                    _a.sent();
                    setComments(function (prev) { return prev.filter(function (c) { return c.id !== commentId; }); });
                    showToastSuccessMessage("Comentario eliminado correctamente", typeAlert.success, setSeeToast);
                    fetchComments();
                    return [3 /*break*/, 5];
                case 3:
                    error_4 = _a.sent();
                    errorForToast = {
                        errors: (error_4 === null || error_4 === void 0 ? void 0 : error_4.errors) || [],
                        message: (error_4 === null || error_4 === void 0 ? void 0 : error_4.message) ||
                            "No se pudo eliminar el comentario. Intente nuevamente.",
                    };
                    showErrorToast(errorForToast, setSeeToast, t, true);
                    return [3 /*break*/, 5];
                case 4:
                    setLoadingDeleteComment(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [quoteId, setSeeToast, t, fetchComments]);
    return {
        comments: comments,
        setComments: setComments,
        loadingPostComment: loadingPostComment,
        loadingPutComment: loadingPutComment,
        loadingDeleteComment: loadingDeleteComment,
        loadingGetComments: loadingGetComments,
        addComment: addComment,
        updateComment: updateComment,
        deleteComment: deleteComment,
        refetchComments: fetchComments,
    };
};
